import React from "react";
import * as H from "../../hooks";
import * as C from "../../Common";
import * as S from "../../services";
import { JSR, TC } from "../../Constants";
import { createRoot } from "react-dom/client";
import { useNavigate } from "react-router-dom";

const ReglementationDashboard: React.FC<{ building: string }> = props => {
    const lg = H.useLanguage();
    const navigate = useNavigate();
    const [html, set_html, status] = H.useAsyncState("");
    const roots_ref = React.useRef<Record<"conformity" | "presence", ReturnType<typeof createRoot>>>({ conformity: null, presence: null });

    React.useEffect(() => {
        let isSubscribed = true;
        S.html_report(({ template: JSR.REG_DOC_P_AND_V_DASHBOARD, params: { building: props.building, lang: lg.prop } as JSR.RegDocPAndVDashboardParams }))
            .then(({ data }) => isSubscribed && set_html(data, "done"))
            .catch(() => isSubscribed && set_html("", "error"));
        return () => {
            isSubscribed = false;
            set_html("", "load");
        }
    }, [set_html, props.building, lg.prop]);

    React.useEffect(() => {
        // Add a click event listener to all table cells with the class "cell-link"
        const cells = document.querySelectorAll<HTMLTableCellElement>("td.cell-link");
        cells.forEach(cell => {
            const url_params = cell.dataset?.url;
            cell.onclick = () => navigate(`/table/reg?${url_params}`);
        });
    });

    React.useEffect(() => {
        // Recuperate the parent span labels
        const label_conformity = document.querySelector<HTMLSpanElement>("#label_kpi_conformity");
        const label_presence = document.querySelector<HTMLSpanElement>("#label_kpi_presence");

        // Does the parent span label exist ?
        if (label_conformity) {
            // Does the parent span label have the current language class ?
            if (!label_conformity.classList.contains(lg.prop)) {
                // Add the current language class to the parent span label
                label_conformity.classList.add(lg.prop);
                // Remove the former tip
                const former_tip = label_conformity.childNodes[0];
                if (former_tip) label_conformity.removeChild(former_tip);
                // Create a new root for the new tip in the new language
                label_conformity.append(document.createElement("span"));
                const new_tip = label_conformity.children[0];
                // Save the root
                if (new_tip) roots_ref.current.conformity = createRoot(new_tip);
            }
        }

        // Does the parent span label exist ?
        if (label_presence) {
            // Does the parent span label have the current language class ?
            if (!label_presence.classList.contains(lg.prop)) {
                // Add the current language class to the parent span label
                label_presence.classList.add(lg.prop);
                // Remove the former tip
                const former_tip = label_presence.childNodes[0];
                if (former_tip) label_presence.removeChild(former_tip);
                // Create a new root for the new tip in the new language
                label_presence.append(document.createElement("span"));
                const new_tip = label_presence.children[0];
                // Save the root
                if (new_tip) roots_ref.current.presence = createRoot(new_tip);
            }
        }

        if (roots_ref.current.presence) roots_ref.current.presence.render(<C.NoRedux.IconTip icon="info-circle" tipContent={lg.getStaticText(TC.REG_DASH_PRESENCE_TIP)} />);
        if (roots_ref.current.conformity) roots_ref.current.conformity.render(<C.NoRedux.IconTip icon="info-circle" tipContent={lg.getStaticText(TC.REG_DASH_CONFORMITY_TIP)} />);
    }, [html, lg]);

    return <C.Spinner status={status} min_load_size="20vh">
        <div className="bg-white text-dark p-2 mb-3 rounded">
            <C.HtmlText html={html} />
        </div>
    </C.Spinner>;
};

export default ReglementationDashboard;